import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Footer from "../Footer/Footer";
import axios from "axios";
import config from "../config";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProfileForm = () => {
  const [formData, setFormData] = useState({
    Empcode: "",
    EmployeeName: "",
    Email: "",
    Designation: "",
    DepartmentName: "",
    Boardroom_Password: "",
  });

  const [avatarPreview, setAvatarPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const EmpCode = localStorage.getItem("Empcode");
      if (!EmpCode) {
        setError("User not found.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${config.API_BASE_URL}/getUsers/${EmpCode}`);
        setFormData(response.data || {});
        // console.log("Fetched User Data:", response.data);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, avatar: file }));
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Updated Data:", formData);
    toast.success("Profile updated successfully!");
  };

  return (
    <Box component="main" sx={{ flexGrow: 1, padding: "20px", paddingLeft: "250px", paddingTop: "55px" }}>
      <Box sx={{ flexGrow: 1, padding: "10px" }}>
        <Card
          sx={{
            width: "100%",
            padding: "0px",
            borderRadius: "10px",
            borderTop: "4px solid blue",
          }}
        >
          <CardContent>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <CircularProgress />
              </Box>
            ) : error ? (
              <Typography color="error" textAlign="center">
                {error}
              </Typography>
            ) : (
              <>
                <TextField
                  fullWidth
                  label="Employee Code"
                  name="Empcode"
                  value={formData.Empcode || ""}
                  //onChange={handleChange}
                  margin="normal"
                />

                <TextField
                  fullWidth
                  label="Employee Name"
                  name="EmployeeName"
                  value={formData.EmployeeName || ""}
                  //onChange={handleChange}
                  margin="normal"
                />

                <TextField
                  fullWidth
                  label="Official Email "
                  name="Email"
                  value={formData.Email || ""}
                  //onChange={handleChange}
                  margin="normal"
                />

                <TextField
                  fullWidth
                  label="Designation"
                  name="Designation"
                  value={formData.Designation || ""}
                  //onChange={handleChange}
                  margin="normal"
                />

                <TextField
                  fullWidth
                  label="Department Name"
                  name="DepartmentName"
                  value={formData.DepartmentName || ""}
                  //onChange={handleChange}
                  margin="normal"
                />

                <TextField
                  fullWidth
                  label="Password"
                  name="Boardroom_Password"
                  type="password"
                  value={formData.Boardroom_Password || ""}
                  //onChange={handleChange}
                  margin="normal"
                  placeholder="Leave blank if you don't want to change the password."
                />

                {/* {avatarPreview && (
                  <Box mt={2} textAlign="center">
                    <Avatar src={avatarPreview} sx={{ width: 80, height: 80, margin: "auto" }} />
                  </Box>
                )}

                <Box mt={2}>
                  <Button variant="outlined" component="label" fullWidth startIcon={<UploadFileIcon />}>
                    Choose File
                    <input type="file" hidden onChange={handleFileChange} />
                  </Button>
                </Box> */}

                <Box mt={3}>
                  <Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
                    Update
                  </Button>
                </Box>
              </>
            )}
          </CardContent>
        </Card>
      </Box>
      <Footer />
      <ToastContainer />
    </Box>
  );
};

export default ProfileForm;